import React from 'react';

import { Wrapper } from './styles';

interface Props {
    count: number;
    isInvalid: boolean;
}

export const CharacterCount = ({ count, isInvalid }: Props) => {
    return <Wrapper $isInvalid={isInvalid}>{count}</Wrapper>;
};
